import React, { createContext, useState, useContext } from "react";

const PrescriptionContext = createContext();

export function usePrescription() {
  return useContext(PrescriptionContext);
}

export const PrescriptionConsumer = PrescriptionContext.Consumer;

export function PrescriptionProvider({ children }) {
    const [ prod, setProd ] = useState({
        'prod1': 'Prod 1',
        'prod2': 'Prod 2',
        'prod3': 'Prod 3' 
    });
    const [ units, setUnits ] = useState({
        'prod1': '10',
        'prod2': '40',
        'prod3': '50'
    });
    const [ columns, setColumns ] = useState({
        0: {},
        1: {},
        2: {} 
    });
    const [ rowSpacingCm, setRowSpacingCm ] = useState("");
    const value = {
        prod,
        setProd,

        units,
        setUnits,

        columns,
        setColumns,

        rowSpacingCm,
        setRowSpacingCm
    };

    return (
        <PrescriptionContext.Provider value={value}>
            {children}
        </PrescriptionContext.Provider>
    );
}
